
import barba from '@barba/core';
//import gsap from 'gsap';

export default class {
    constructor(){
        barba.hooks.once((data) => {
            this.init()
        })
        barba.hooks.after((data) => {
            this.init()
        })
    }
    init (){
        let themeDark = document.getElementById('l-drawer__theme--dark');
        let themeLight = document.getElementById('l-drawer__theme--light');
        if(themeLight){
            themeLight.addEventListener('click', function(){
                document.body.classList.remove("theme--dark");
                document.body.classList.add("theme--light");
            });
        }
        if(themeDark){
            themeDark.addEventListener('click', function(){
                document.body.classList.add("theme--dark");
                document.body.classList.remove("theme--light");
            });
        }
    }
}
